module.exports = __webpack_public_path__ + "static/img/balz808-663-370-gld.cc12a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz808-663-370-gld.jpg
// module id = qS/9
// module chunks = 0